export default __webpack_public_path__ + "static/media/dialog_info.0f3a84b0.svg";